import { Action, Reducer } from "redux";
import { DragDropScreenActionTypes, DragDropScreenState, DragDropScreenTypes } from "./dragDropScreenTypes";

export const INITIAL_STATE: DragDropScreenState = {
	dragDropScreen: {
		data: false,
	},
};

const dragDropScreenReducer: Reducer<DragDropScreenState> = (
	state: DragDropScreenState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as DragDropScreenActionTypes;
	switch (actionTypes.type) {
		case DragDropScreenTypes.UPDATE_DRAGGING:
			return {
				...state,
				dragDropScreen: {
					...state.dragDropScreen,
					data: actionTypes.payload.data,
				},
			};
		case DragDropScreenTypes.RESET_DRAG_DROP:
			return {
				...state,
				dragDropScreen: INITIAL_STATE.dragDropScreen,
			};
		default:
			return state;
	}
};

export default dragDropScreenReducer;
